/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_login_required13 = /** @type {(inputs: {}) => string} */ () => {
	return `You need to be logged in to perform this action`
};

const fr_login_required13 = /** @type {(inputs: {}) => string} */ () => {
	return `Vous devez être connecté pour effectuer cette action`
};

const de_login_required13 = /** @type {(inputs: {}) => string} */ () => {
	return `Sie müssen angemeldet sein, um diese Aktion auszuführen`
};

const es_login_required13 = /** @type {(inputs: {}) => string} */ () => {
	return `Necesita iniciar sesión para realizar esta acción.`
};

const it_login_required13 = /** @type {(inputs: {}) => string} */ () => {
	return `Devi aver effettuato l'accesso per eseguire questa azione`
};

const ar_login_required13 = /** @type {(inputs: {}) => string} */ () => {
	return `يجب عليك تسجيل الدخول للقيام بهذا الإجراء`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const login_required13 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_required13(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_required13", locale)
	if (locale === "en") return en_login_required13(inputs)
	if (locale === "fr") return fr_login_required13(inputs)
	if (locale === "de") return de_login_required13(inputs)
	if (locale === "es") return es_login_required13(inputs)
	if (locale === "it") return it_login_required13(inputs)
	return ar_login_required13(inputs)
};
export { login_required13 as "LOGIN_REQUIRED" }